export default {
  // Text Panel
  '文本': 'Texte',
  '颜色': 'Couleur',
  '字体': 'Police',
  '大写': 'Majuscules',
  '字号': 'Taille de police',
  '背景色': 'Couleur de fond',
  '圆角': 'Rayon de bordure',
  '内边距': 'Rembourrage',
  '描边': 'Contour',
  '对齐': 'Alignement',
  '底边距': 'Marge inférieure',
  '紧贴底边': 'Alignement bas',
  '垂直居中': 'Centrage vertical',

  // Basic Panel
  '基础': 'Basique',
  '位置': 'Position',
  '尺寸': 'Taille',
  '旋转': 'Rotation',
  '居中': 'Centrer',
  '原始尺寸': 'Taille originale',
  '平铺': 'Mosaïque',
  '拉伸': 'Étirer',
  '透明度': 'Opacité',
  '视频尺寸为{width}x{height}。': 'La taille de la vidéo est {width}x{height}.',
  '调整文本尺寸可能会改变文本展示效果，建议调整字体大小': 'Ajuster la taille du texte peut modifier son affichage, il est recommandé d\'ajuster la taille de la police',

  // Library
  '视频': 'Vidéo',
  '音频': 'Audio',
  '图片': 'Image',
  '新建文本': 'Nouveau texte',
  '花字库': 'Bibliothèque de polices',
  '默认文本': 'Texte par défaut',

  // Export
  '导出': 'Exporter',

  // Tools
  '撤销': 'Annuler',
  '重做': 'Rétablir',

  // Tooltips
  '清除选中': 'Effacer la sélection',
  '删除当前选中': 'Supprimer la sélection',
  '分割当前选中': 'Diviser la sélection',
  '分割当前选中，只保留左侧': 'Diviser la sélection, conserver seulement la gauche',
  '分割当前选中，只保留右侧': 'Diviser la sélection, conserver seulement la droite',
  '水平翻转': 'Retourner horizontalement',
  '将连续且相邻的素材拼接后下载': 'Concaténer et télécharger les matériaux adjacents',

  // Library
  '当前': 'Actuel',
  '导入': 'Importer',
  '全部': 'Tous',
  '删除': 'Supprimer',
  '拖拽视频到这里': 'Glissez la vidéo ici',
  '拖拽音频到这里': 'Glissez l\'audio ici',
  '拖拽图片到这里': 'Glissez l\'image ici',
  '或者点击上传': 'ou cliquez pour télécharger',
  '暂无素材，请先导入素材': 'Aucun matériel disponible, veuillez d\'abord importer des matériaux',

  // Manager
  '选择一个视频，开始你的创作。': 'Sélectionnez une vidéo et commencez votre création.',

  // Animation Panel
  '动画': 'Animation',
  '入场动画': 'Animation d\'entrée',
  '出场动画': 'Animation de sortie',
  '关键帧动画': 'Animation de keyframe',
  '选择动画效果': 'Sélectionnez un effet d\'animation',
  '添加': 'Ajouter',
  '确定删除此动画？': 'Êtes-vous sûr de vouloir supprimer cette animation?',
  '持续时间': 'Durée',
  '秒': 'sec',
  '起始时间': 'Heure de début',
  '结束时间': 'Heure de fin',
  '暂无动画，请添加动画效果': 'Aucune animation, veuillez ajouter des effets d\'animation',

  // Animation Presets
  '淡入': 'Entrée douce',
  '从左滑入': 'Glisser depuis la gauche',
  '从右滑入': 'Glisser depuis la droite',
  '从上滑入': 'Glisser depuis le haut',
  '从下滑入': 'Glisser depuis le bas',
  '放大进入': 'Agrandir',
  '旋转进入': 'Rotation entrée',
  '淡出': 'Sortie douce',
  '向左滑出': 'Glisser vers la gauche',
  '向右滑出': 'Glisser vers la droite',
  '向上滑出': 'Glisser vers le haut',
  '向下滑出': 'Glisser vers le bas',
  '缩小退出': 'Réduire',
  '旋转退出': 'Rotation sortie',
  '脉冲': 'Impulsion',
  '抖动': 'Secouer',
  '弹跳': 'Rebond',
  '摆动': 'Balancement',
  '闪烁': 'Clignotement',
  '自定义': 'Personnalisé',
  '起始状态': 'État initial',
  '结束状态': 'État final',
  '位置 X': 'Position X',
  '位置 Y': 'Position Y',
  '缩放': 'Échelle',
  '旋转角度': 'Rotation',
  '不透明度': 'Opacité',

  // Filter Panel
  '可用滤镜': 'Filtres disponibles',
  '滤镜参数': 'Paramètres du filtre',
  '选择滤镜': 'Sélectionner un filtre',
  '请选择要编辑的滤镜': 'Veuillez sélectionner un filtre à modifier',
  '强度': 'Intensité',
  '请选择一个滤镜以调节参数': 'Veuillez sélectionner un filtre pour ajuster les paramètres',
  '灰度': 'Niveaux de gris',
  '模糊': 'Flou',
  '亮度': 'Luminosité',
  '对比度': 'Contraste',
  '饱和度': 'Saturation',

  '无': 'Aucun',
  '入场': 'Entrée',
  '出场': 'Sortie',
  '动效': 'Animation',
  '结束位置': 'Position de fin',
  '使用当前时间轴上的当前时间点': 'Utiliser le point de temps actuel sur la chronologie',
  '开始位置': 'Position de départ',
  '当前有动画，调整可能不能直接看到效果，请播放片段查看': 'L\'animation actuelle peut ne pas afficher d\'effet direct, veuillez lire le segment pour vérifier',
  '滤镜': 'Filtre',
  '恢复正在编辑的数据': 'Restaurer les données en cours d\'édition',
  '转场': 'Transition',
  '转场效果': 'Effets de transition',
  '点击应用': 'Cliquez pour appliquer',
  '仅支持视频和图片': 'Prend en charge uniquement les vidéos et les images',
  '删除转场': 'Supprimer la transition',
  '已经存在视频转场，请先删除': 'Une transition vidéo existe déjà, veuillez la supprimer d\'abord',
  '当前片段是轨道最后一个片段，不能应用转场效果': 'Le segment actuel est le dernier de la piste, impossible d\'appliquer un effet de transition',
  '暂无转场效果': 'Aucun effet de transition disponible',
  '片段不存在': 'Segment n\'existe pas',
  '请先选择一个片段': 'Veuillez d\'abord sélectionner un segment',
  '轨道不存在': 'Piste n\'existe pas',
  '默认': 'Par défaut',

  // 转场效果
  '淡入淡出': 'Fondu',
  '滑动': 'Glissement',
  '百叶窗': 'Persiennes',
  '溶解': 'Dissolution',

  // Video/Audio Panel
  '音量': 'Volume',
  '请先选择视频片段': 'Veuillez d\'abord sélectionner un segment vidéo',
  '请先选择音频片段': 'Veuillez d\'abord sélectionner un segment audio',
  '重置': 'Réinitialiser',

  // Advanced Export
  '高级导出': 'Export avancé',
  '取消': 'Annuler',
  '正在导出...': 'Exportation en cours...',
  '导出完成！': 'Exportation terminée !',
  '导出失败：': 'Échec de l\'exportation :',
  '导出类型': 'Type d\'exportation',
  '输出格式': 'Format de sortie',
  '分辨率': 'Résolution',
  '帧率': 'FPS',
  '视频比特率': 'Débit vidéo',
  '编码格式': 'Format d\'encodage',
  '包含音频': 'Inclure l\'audio',
  '关闭时将导出无声音的视频': 'La fermeture exportera une vidéo sans son',
  '音频比特率': 'Débit audio',
  '比特率': 'Débit',
  '采样率': 'Taux d\'échantillonnage',
  '导出中...': 'Exportation en cours...',
  '开始导出': 'Démarrer l\'exportation',
};